import * as React from "react";

import {
    InitialWorkAdjustmentQuestionnaire as InitialWorkAdjustmentQuestionnaireCommon
} from "@teamprevent/common/workAdjustment/components/InitialWorkAdjustmentQuestionnaire";

const InitialWorkAdjustmentQuestionnaire: React.FunctionComponent = () => {
    return (
        <InitialWorkAdjustmentQuestionnaireCommon
            readonly={false}
            ohCaseId={null}
            taskId={null}
            customerId={null}
            employeeRecordId={null}
            questionnaire={null}
            parentReferralReport={null}
            loadQuestionnaire={null}
            submitQuestionnaire={null}
            notesFromMeetingApiUrl={null}
            fileApiUrl={null}
            onSendDocumentsToAssociate={null}
        />
    );
};

export { InitialWorkAdjustmentQuestionnaire };
